import React from 'react';
import I18n from 'i18n-js';

import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import UspsLogo from '@reverbdotcom/cadence/images/vendor/usps-logo.svg';
import UspsLogoWhite from '@reverbdotcom/cadence/images/vendor/usps-logo-white.svg';
import UpsLogo from '@reverbdotcom/cadence/images/vendor/ups-logo.svg';
import { RCImage } from '@reverbdotcom/cadence/components';

export function SelectedCarrier({ carrier }: { carrier: string }) {
  if (carrier !== 'USPS' && carrier !== 'UPS') {
    return null;
  }

  const logo = carrier === 'USPS' ? UspsLogo : UpsLogo;
  const darkModeLogo = carrier === 'USPS' ? UspsLogoWhite : null;
  const logoClassName = carrier === 'USPS' ? 'selected-carrier__logo-container-usps' : 'selected-carrier__logo-container-ups';

  return (
    <div className="selected-carrier">
      <div className={logoClassName}>
        <RCImage
          src={logo}
          darkModeSrc={darkModeLogo}
          alt={carrier}
          imageBox="auto"
        />
      </div>
      <div className="selected-carrier__text">
        <SanitizedRender
          html={I18n.t(`discovery.sellForm.shippingSection.carrierCalculatedForm.selectedCarrier.${carrier.toLowerCase()}`)}
        />
      </div>
    </div>
  );
}
